"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSiteNumberInput = validateSiteNumberInput;
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_types_1 = require("@caddigital/sok-types");
var projectMembersActions = require("@caddigital/sok-reducers/lib/actions/project/members");
var lightAdminActions = require("@caddigital/sok-reducers/lib/actions/project/lightAdmin");
require("./index.scss");
var modals_1 = require("./modals");
var mapStateToProps = function (state) {
    return {
        createEdit: state.project.members.createEditModal,
        groups: state.project.members.groups
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(projectMembersActions.toggleModal()); },
    updateName: function (_a) {
        var value = _a.target.value;
        return dispatch(projectMembersActions.setUserGroupName(value));
    },
    createCategory: function (project, name, description) {
        return dispatch(projectMembersActions.createCategoryRequest(project.id, name, description));
    },
    createProfile: function (project, categoryId, name, description, copiedProfileId, period) {
        return dispatch(projectMembersActions.createUserProfileRequest(project.id, categoryId, name, description, copiedProfileId, period));
    },
    createTRMVRMeter: function (project, name, siteNumber, mvrmeter) {
        return dispatch(projectMembersActions.createTRMVRMeterRequest(project.id, name, !mvrmeter
            ? sok_types_1.TRMVRMeter.iTRMVRMeterTypes.TRMETER
            : sok_types_1.TRMVRMeter.iTRMVRMeterTypes.MVRMETER, siteNumber));
    },
    createWorksiteDiary: function (project, name, worksitediarynumber) {
        return dispatch(projectMembersActions.createWorksiteDiaryRequest(project.id, name, worksitediarynumber));
    },
    createLightAdmin: function (_a) {
        var projectId = _a.projectId, categoryId = _a.categoryId, name = _a.name, description = _a.description, inviteRightsTo = _a.inviteRightsTo;
        return dispatch(lightAdminActions.createLightAdminRequest({
            projectId: projectId,
            categoryId: categoryId,
            name: name,
            description: description,
            inviteRightsTo: inviteRightsTo
        }));
    }
}); };
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('selectedCategory', 'setSelectedCategory', null), (0, recompose_1.withState)('name', 'setName', ''), (0, recompose_1.withState)('description', 'setDescription', ''), (0, recompose_1.withState)('userProfiles', 'setUserProfiles', []), (0, recompose_1.withState)('copiedUserProfile', 'setCopiedUserProfile', undefined), (0, recompose_1.withState)('validSince', 'setValidSince', null), (0, recompose_1.withState)('validUntil', 'setValidUntil', null), (0, recompose_1.withState)('siteNumber', 'setNumber', ''), (0, recompose_1.withState)('inviteRightsTo', 'setInviteRightsTo', []), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.setSelectedCategory(null);
        this.props.setName('');
        this.props.setDescription('');
        this.props.setUserProfiles([]);
        this.props.setCopiedUserProfile(undefined);
        this.props.setValidSince(null);
        this.props.setValidUntil(null);
        this.props.setNumber('');
        this.props.setInviteRightsTo([]);
        if (['USER_PROFILE', 'LIGHT_ADMIN'].includes(this.props.createEdit.type)) {
            this.props.setUserProfiles(this.props.groups.reduce(function (acc, c) {
                return c.groups.reduce(function (ac, g) {
                    ac.push(g);
                    return ac;
                }, acc);
            }, []));
        }
        if (this.props.createEdit.type === 'SOKOBID') {
            var briefcases = this.props.groups.filter(function (x) { return x.category.type === 'SokoBidCategoryUserGroup'; });
            if (briefcases.length === 1) {
                this.props.setSelectedCategory(briefcases[0].category);
            }
        }
    },
    shouldComponentUpdate: function (prevProps) {
        if (this.props.createEdit.status !== prevProps.createEdit.status ||
            this.props.createEdit.status === 'CREATE') {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
function validateSiteNumberInput(evt) {
    if (evt.key === 'Enter') {
        return;
    }
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var charFromKey = String.fromCharCode(key);
    var regex = /[0-9]|\./;
    if (!regex.test(charFromKey)) {
        if (theEvent.preventDefault)
            theEvent.preventDefault();
        return false;
    }
}
exports.default = enhance(function (props) { return (0, modals_1.getModal)(props.createEdit.type, props); });
